import { render } from "./TechnicalSkill.vue?vue&type=template&id=34461438&scoped=true"
import script from "./TechnicalSkill.vue?vue&type=script&lang=ts"
export * from "./TechnicalSkill.vue?vue&type=script&lang=ts"

import "./TechnicalSkill.vue?vue&type=style&index=0&id=34461438&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-34461438"

export default script